/** Returns the parsed URL if it is an https SharePoint link, otherwise null. */
export function parseSharePointVideoUrl(value: string | null | undefined): URL | null {
  const trimmed = value?.trim();
  if (!trimmed) { return null; }
  try {
    const url = new URL(trimmed);
    const host = url.hostname.toLowerCase();
    const isSharePoint = host === 'sharepoint.com' || host.endsWith('.sharepoint.com');
    return url.protocol === 'https:' && isSharePoint ? url : null;
  } catch {
    return null;
  }
}
